import { useMemo } from 'react';
import { useExtraResourceEbook } from 'store/extraResource/selectors';
import { combineBookIdsAndPageIdsWithUnique, processResource } from './helper';

const useGetExtensionAssignments = ({ bookPageId }) => {
  const extraResource = useExtraResourceEbook();

  const filterExtraResource = useMemo(() => {
    return extraResource?.filter((item) => item?.pageId == bookPageId) || [];
  }, [bookPageId, extraResource]);

  const configExtraResource = useMemo(() => {
    const bookWithPageId = {};

    if (!filterExtraResource.length) return bookWithPageId;

    filterExtraResource.forEach((element) => {
      processResource(element, bookWithPageId);
    });

    return bookWithPageId;
  }, [filterExtraResource]);

  return {
    configBookIdPageId: combineBookIdsAndPageIdsWithUnique(configExtraResource),
    configExtraResource:configExtraResource
  };
};

export default useGetExtensionAssignments;
